import React, { memo, useMemo } from 'react';
import { Box } from 'native-base';
import { ApprovedIcon, DisclosuresIcon, HomeOwnersInsuranceIcon, OtherDocumentsIcon, PayStubIcon, PendingReviewIcon, TaxReturnsIcon, UploadHistoryIcon, W2Icon } from '../../assets';
import { Platform } from 'react-native';
const AvatarIcon = _ref => {
  let {
    name,
    height = 16,
    width = 16,
    bgColor = 'circle.secondary',
    isOnlyIcon = false
  } = _ref;
  console.log(name);
  const Icon = useMemo(() => {
    switch (name) {
      case 'Upload History':
        return /*#__PURE__*/React.createElement(UploadHistoryIcon, null);
      case 'Disclosures':
        return /*#__PURE__*/React.createElement(DisclosuresIcon, null);
      case 'Tax Returns':
        return /*#__PURE__*/React.createElement(TaxReturnsIcon, null);
      case "Homeowner's Insurance":
        return /*#__PURE__*/React.createElement(HomeOwnersInsuranceIcon, null);
      case 'Pay Stub':
        return Platform.OS === 'web' ? /*#__PURE__*/React.createElement(PayStubIcon, {
          width: 35,
          height: 28
        }) : /*#__PURE__*/React.createElement(OtherDocumentsIcon, null);
      case 'Approved':
        return /*#__PURE__*/React.createElement(ApprovedIcon, null);
      case 'Pending Review':
        return /*#__PURE__*/React.createElement(PendingReviewIcon, null);
      case 'W-2':
        return Platform.OS === 'web' ? /*#__PURE__*/React.createElement(W2Icon, {
          width: 34,
          height: 36
        }) : /*#__PURE__*/React.createElement(OtherDocumentsIcon, null);
      default:
        return /*#__PURE__*/React.createElement(OtherDocumentsIcon, null);
    }
  }, [name]);
  if (isOnlyIcon) return Icon;
  return /*#__PURE__*/React.createElement(Box, {
    h: height,
    w: width,
    rounded: "full",
    bg: bgColor,
    justifyContent: "center",
    alignItems: "center",
    accessibilityLabel: name,
    testID: name
  }, Icon);
};
export default /*#__PURE__*/memo(AvatarIcon);
//# sourceMappingURL=index.js.map